/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { ModuleCheckerService } from "src/app/core/services/moduleChecker.service";
import { ICONS } from "src/app/core/constants/icons";
import { VOUCHER_TAB_MENU_ITEMS, VOUCHER_TAB_FILTER_MENU_ITEMS } from "src/app/core/constants/menuItems";
import * as ButtonSelectionActions from "src/app/state/actions/button-click.actions";
import { Subject, takeUntil } from "rxjs";
import { selectVouchersFilterName, selectVouchersModuleName } from "src/app/state/reducer/buttons.reducer";
import { ButtonsState } from "src/app/state/buttons-state";
import { Router } from "@angular/router";
import { ROUTES } from "src/app/core/constants/routes";

@Component({
  selector: "app-vouchers-tabs",
  templateUrl: "./vouchers-tabs.component.html",
  styleUrls: ["./vouchers-tabs.component.scss"]
})

export class VouchersTabsComponent implements OnInit, OnDestroy {

  protected voucherCategoryFilterTabs = VOUCHER_TAB_FILTER_MENU_ITEMS;
  protected VOUCHER_ICON = ICONS.VOUCHER_ICON;
  protected voucherTabs = VOUCHER_TAB_MENU_ITEMS;

  private $vouchersModule = this.buttonsStore.pipe(select(selectVouchersModuleName));
  private $vouchersFilter = this.buttonsStore.pipe(select(selectVouchersFilterName));

  private ngUnsubscribe = new Subject<void>();
  private selectedModule: string = "";
  private selectedFilter: string = "";

  constructor(private buttonsStore: Store<ButtonsState>,
    protected moduleCheckerService: ModuleCheckerService,
    private router: Router) {
  }

  ngOnInit(): void {
    this.$vouchersModule
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(selectedModule => {
        this.selectedModule = selectedModule;
        this.isButtonSelected(this.selectedModule);
      });

    this.$vouchersFilter
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(selectedFilter => {
        this.selectedFilter = selectedFilter;
        this.buttonsStore.dispatch(ButtonSelectionActions.FILTER_VOUCHERS_BY_CATEGORY({ categoryName: this.selectedFilter }));
      });
  }

  isButtonSelected(buttonName: string): boolean {
    return buttonName === this.selectedModule;
  }

  selectButton(buttonName: string): void {
    this.selectedModule = buttonName;
    this.buttonsStore.dispatch(ButtonSelectionActions.VOUCHERS_MODULE_SELECTED({ button: buttonName }));
    this.router.navigate([ROUTES.МАX_VOUCHERS]);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
